<img src="../../../../assets/images/customer_service_qrcode_new.png" />

<p>请使用微信扫描二维码联系客服</p>
<p>客服在线时间8:00-17:00</p>
